<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center vh-100"
  >
    <div class="text-center">
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="fw-semibold text-muted">Sedang logout...</p>
    </div>
  </div>
</template>

<script>
import { config } from '@/utils/config.js';

export default {
  name: 'LogoutSession',

  data() {
    return {
      ssoConfig: config.ssoConfig,
    };
  },

  created() {
    this.logout();
  },

  methods: {
    logout() {
      try {
        const loginType = localStorage.getItem('loginType');

        if (loginType === 'SSO') {
          localStorage.removeItem('token');
          localStorage.removeItem('loginType');
          localStorage.removeItem('userData');
          localStorage.clear();
          sessionStorage.clear();
          window.location.replace('/pages/login');
        } else {
          window.location.replace('/dashboard');
        }
      } catch (error) {
        console.error('Logout error:', error);
        // fallback jika ada error
        window.location.replace('/pages/login');
      }
    },
  },
};
</script>

<style scoped>
.spinner-border {
  width: 2.5rem;
  height: 2.5rem;
}
</style>
